/**
 * Recursively converts null values to undefined for MobX-State-Tree compatibility.
 * MST doesn't accept null for optional fields, only undefined.
 */
export function convertNullToUndefined<T>(obj: T): T {
  if (obj === null) {
    return undefined as T
  }
  if (typeof obj !== 'object') {
    return obj
  }
  if (Array.isArray(obj)) {
    return obj.map(convertNullToUndefined) as T
  }
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
    result[key] = convertNullToUndefined(value)
  }
  return result as T
}
